import { styled } from "styled-components";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { cssFontSize, cssSpacing } from "../../util/styles.js";
import { VerticalSpacer } from "../../internal-components/Layout.js";

export const InfoKortSpacer = styled(VerticalSpacer)`
  @media (min-width: ${mobileBreakPointCSS}) {
    margin-top: ${cssSpacing("s")};
  }
`;

export const InfoKortCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${cssSpacing("s")};
  background: var(--job-info-card-background);
  border-radius: ${(props) => props.theme.borderRadius};
  padding: ${cssSpacing("s")};

  @media (min-width: ${mobileBreakPointCSS}) {
    flex-direction: row;
    align-items: center;
    gap: ${cssSpacing("l")};
    padding: ${cssSpacing("m")};
  }
`;

export const InfoKortApply = styled.div`
  flex-shrink: 0;

  @media (min-width: ${mobileBreakPointCSS}) {
    margin-left: auto;
  }
`;

export const InfoKortMeta = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${cssSpacing("xs")} ${cssSpacing("s")};

  @media (min-width: ${mobileBreakPointCSS}) {
    display: flex;
    flex-direction: row;
    gap: 100px;
  }
`;

export const InfoKortMetaItem = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 4px;

  svg {
    flex-shrink: 0;
    color: var(--job-info-icon-color);

    path {
      fill: none;
    }
  }
`;

export const InfoKortMetaLabel = styled.span`
  display: block;
  font-size: ${cssFontSize("tiny")};
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--job-info-meta-label-color);
`;

export const InfoKortMetaValue = styled.span`
  display: block;
  font-size: ${cssFontSize("small")};
  color: var(--job-info-meta-value-color);
`;
